var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_982_8375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8779 0.905273H2.136C1.45979 0.905273 0.911621 1.45344 0.911621 2.12965V21.8715C0.911621 22.5477 1.45979 23.0959 2.136 23.0959H21.8779C22.5541 23.0959 23.1022 22.5477 23.1022 21.8715V2.12965C23.1022 1.45344 22.5541 0.905273 21.8779 0.905273Z",
    fill: "#3D5A98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2208 23.0943V14.5012H19.1046L19.5358 11.1524H16.2208V9.01492C16.2208 8.04555 16.4908 7.38367 17.8802 7.38367H19.6539V4.38367C18.795 4.29432 17.9319 4.25176 17.0683 4.25617C14.5146 4.25617 12.7558 5.81242 12.7558 8.68305V11.1524H9.87207V14.5012H12.7558V23.0943H16.2208Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_982_8375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon_facebook.7508f1131584623e00fa543cf239e367.svg";
export { ForwardRef as ReactComponent };